import { render } from "./side-panel-teacher.vue?vue&type=template&id=30525e2a&scoped=true"
import script from "./side-panel-teacher.vue?vue&type=script&lang=js"
export * from "./side-panel-teacher.vue?vue&type=script&lang=js"

import "./side-panel-teacher.vue?vue&type=style&index=0&id=30525e2a&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30525e2a"],['__file',"src/components/admin-dashboard/panels/side-panel-teacher.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "30525e2a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('30525e2a', __exports__)) {
    api.reload('30525e2a', __exports__)
  }
  
  module.hot.accept("./side-panel-teacher.vue?vue&type=template&id=30525e2a&scoped=true", () => {
    api.rerender('30525e2a', render)
  })

}


export default __exports__